import { request } from '@umijs/max';

// 获取订单分页列表
export async function getOrderPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/shop/order/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
      with: [
        'shop',
        'brand',
        'category.parent.parent',
        'imageList',
        'attrList',
        'optionList',
      ],
    },
  });
}

// 获取订单详情
export async function getOrderInfo(values: API.FormValues) {
  return request('/api/shop/order/info', {
    method: 'POST',
    data: {
      ...values,
      with: [
        'goodList',
        'payList',
        'refundList',
        'shop',
        'user',
        'operator',
        'streetAdminUser',
        'districtAdminUser',
        'leaseContracts',
        'payVouchers',
        'subsidyInvoices',
        'subsidyPromises',
      ],
    },
  });
}

// 发货
export async function sendOrder(values: API.FormValues) {
  return request('/api/shop/order/send', {
    method: 'POST',
    data: values,
  });
}

// 申请结算
export async function applySettle(values: API.FormValues) {
  return request('/api/shop/order/settleApply', {
    method: 'POST',
    data: values,
  });
}

// 取消订单
export async function cancelOrder(values: API.FormValues) {
  return request('/api/shop/order/cancel', {
    method: 'POST',
    data: values,
  });
}

// 保存订单文件（凭证）
export async function saveOrderFiles(values: API.FormValues) {
  return request('/api/shop/order/saveFiles', {
    method: 'POST',
    data: values,
  });
}

// 创建订单
export async function createOrder(values: API.FormValues) {
  return request('/api/shop/order/order', {
    method: 'POST',
    data: values,
  });
}

// 编辑订单
export async function editOrder(values: API.FormValues) {
  return request('/api/shop/order/edit', {
    method: 'POST',
    data: values,
  });
}

// 编辑订单备注
export async function editOrderRemark(values: { id: string; remark: string }) {
  return request('/api/shop/order/remark', {
    method: 'POST',
    data: values,
  });
}

// 订单预览
export async function previewOrder(values: API.FormValues) {
  return request('/api/shop/order/preview', {
    method: 'POST',
    data: values,
  });
}

// 获取商品分页列表（用于选择商品）
export async function getGoodPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter?: string;
}) {
  return request('/api/shop/good/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
      with: ["shop","brand","category.parent.parent","imageList","attrList","optionList"]
    },
  });
}

// 获取用户列表（用于选择用户）
export async function getUserList({
  filter,
  current = 1,
  pageSize = 20,
  sorter = { id: 'asc' },
}: {
  filter?: API.FormValues;
  current?: number;
  pageSize?: number;
  sorter?: any;
}) {
  return request('/api/shop/user/page', {
    method: 'POST',
    data: {
      filter: filter || {},
      current,
      pageSize,
      sorter,
    },
  });
}

// 获取COS文件真实访问链接
export async function getViewUrl(params: { url: string[] }) {
  return request('/api/shop/cos/viewUrl', {
    method: 'POST',
    data: params,
  });
}

// 回收
export async function backOrder(values: API.FormValues) {
  return request('/api/shop/order/back', {
    method: 'POST',
    data: values,
  });
}

// 退款预览
export async function refundPreview(values: API.FormValues) {
  return request('/api/shop/order/refundPreview', {
    method: 'POST',
    data: values,
  });
}

// 确认退款
export async function refundOrder(values: API.FormValues) {
  return request('/api/shop/order/refund', {
    method: 'POST',
    data: values,
  });
}

// 现金支付
export async function payByCash(values: API.FormValues) {
  return request('/api/shop/order/payByCash', {
    method: 'POST',
    data: values,
  });
}

// 获取支付二维码URL
export async function getPayUrl(values: API.FormValues) {
  return request('/api/shop/order/payUrl', {
    method: 'POST',
    data: values,
  });
}

// 导出订单
export async function exportOrder(values: API.FormValues) {
  return request('/api/shop/order/export', {
    method: 'POST',
    data: values,
    responseType: 'blob',
  });
}
